import { render, staticRenderFns } from "./AgendaItem.vue?vue&type=template&id=61a52118"
import script from "./AgendaItem.vue?vue&type=script&setup=true&lang=js"
export * from "./AgendaItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AgendaItem.vue?vue&type=style&index=0&id=61a52118&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports